export default "__VITE_ASSET__a48821ed__"